import { validationIsEqual } from '../status';
import { validateDateOfBirth, validateName, validateAlphaNumericStringAllowingOnlyNumbers, validateNumericString, validateAlphaNumericString } from '@om/validation';
import {
    FIRST_NAME_SET_VALUE,
    GENDER_SET_VALUE,
    DOB_SET_VALUE,
    STREET_ADDRESS_SET_VALUE,
    CITY_SET_VALUE,
    SUBURB_SET_VALUE,
    POSTAL_ADDRESS_SET_VALUE,
    setPostalAddressValid,
    setFirstNameValid,
    setGenderValid,
    setDOBValid,
    setCityValid,
    setSuburbValid,
    setStreetAddressValid,
    NIHF_NUMBER_SET_VALUE,
    setNihfNumberValid,
} from '../../../actions/afyaImara/childDetails';
import { validateDOBByAge } from './spouseDetails';
import { getQuoteForm } from '../../../selectors/afyaImara/quote';

let prevValidationAction = null;
export const childDetailsValidation = (store, next, action) => {
    const quote = getQuoteForm(store.getState());
    const validationAction = (() => {
        let error;
        switch (action.type) {
            case FIRST_NAME_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 48,
                    subject: 'Full Name',
                });

                //console.log(setFirstNameValid(action.index, error));

                return setFirstNameValid(action.index, error);

            case GENDER_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 64,
                    subject: 'Gender',
                });
                return setGenderValid(action.index, error);

                case NIHF_NUMBER_SET_VALUE:
                    error = validateNumericString(action.value, {
                        min: 7,
                        subject: 'Nhif number',
                    });
                    return setNihfNumberValid(action.index, error);

            case DOB_SET_VALUE:
                console.log(quote.childrenDobs[action?.index], 'hgfjshgfsd')
                error = validateDOBByAge(action.value, parseInt(quote.childrenDobs.value[action?.index]));
                return setDOBValid(action.index, error);


            case STREET_ADDRESS_SET_VALUE:
                error = validateAlphaNumericString(action.value, {
                    min: 2,
                    max: 64,
                    subject: 'Street Address',
                });
                return setStreetAddressValid(action.index, error);

            case CITY_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 64,
                    subject: 'Street Address',
                });
                return setCityValid(action.index, error);

            case SUBURB_SET_VALUE:
                error = validateName(action.value, {
                    min: 2,
                    max: 64,
                    subject: 'Suburb',
                });
                return setSuburbValid(action.index, error);

            case POSTAL_ADDRESS_SET_VALUE:
                error = validateAlphaNumericStringAllowingOnlyNumbers(action.value);
                return setPostalAddressValid(action.index, error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
